import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Tooltip } from "reactstrap";
import Icon from "../../components/UI/Icon";
import { PlanResponse } from "../../services/plansGet";
import { fetchPlans as fetchPlansAction } from "../../store/plans/action";
import { PlansState } from "../../store/plans/types";
import { ReportSummaryState } from "../../store/reportSummary/types";
import { AppState } from "../../store/store";
import styles from "./NoSubscription.module.scss";

interface Props {
  title?: string;
  plansState: PlansState;
  reportSummaryState: ReportSummaryState;
  fetchPlans(): void;
}

const NoSubscription = ({
  title,
  reportSummaryState,
  plansState,
  fetchPlans,
}: Props) => {
  const [plans, setPlans] = useState<PlanResponse[]>([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  useEffect(() => {
    fetchPlans();
  }, []);
  useEffect(() => {
    if (plansState.status === "loaded") {
      const plans = plansState.payload;
      setPlans(plans);
    }
  }, [plansState]);
  let totalProducts = 0;
  if (reportSummaryState.status === "loaded" && reportSummaryState.payload) {
    const { payload } = reportSummaryState;
    const accountsCount = (payload.accounts && payload.accounts.length) || 0;
    const servicesCount = (payload.contractsAndServices && payload.contractsAndServices.length) || 0;
    const cardsCount = (payload.creditCards && payload.creditCards.length) || 0;
    const creditsCount = (payload.credits && payload.credits.length) || 0;
    totalProducts = accountsCount + servicesCount + cardsCount + creditsCount;
  }

  return (
    <div className={`${styles.card} eb-card`} id="no_subscription_card">
      <div className={styles.header}>
        <h2 className={styles.mainTitle}>Tu historial crediticio en un solo lugar</h2>
        <div className={styles.infoAvatar}>
          <>
            <Icon
              id={`info`}
              icon="info"
              className={styles.icon}
            />
            <Tooltip
              target={`info`}
              placement="left"
              isOpen={tooltipOpen}
              toggle={() => setTooltipOpen(!tooltipOpen)}
            >
              Tu información crediticia es actualizada cada 30 días por los burós de crédito,
              Conoce como está la tuya eligiendo uno de los tres tipos de consultas que tenemos
              para que obtengas la información completa de tu puntaje.
            </Tooltip>
          </>
        </div>
      </div>
      {plans.length > 0 && (
        <p className={styles.price}>
          {totalProducts > 0
            ? `¡Tienes ${totalProducts} productos financieros! `
            : ""}
          Descubre el detalle desde ${plans[0].cost.toLocaleString("es-ES")}
        </p>
      )}
      <ul className={styles.featureList}>
        <li className={styles.featureItem}>
          <span className={styles.checkIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </span>
          Conoce tu puntaje y tu reporte de crédito
        </li>
        <li className={styles.featureItem}>
          <span className={styles.checkIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </span>
          Mantente al día con reportes y alertas
        </li>
        <li className={styles.featureItem}>
          <span className={styles.checkIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
          </span>
          Obtén asesoría y soporte personalizado cuando lo necesites
        </li>
      </ul>
      <Link className={styles.actionLink} to="/plan-consultas">
        <button className={styles.actionButton}>
          Ver mi historial
        </button>
      </Link>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    plansState: state.plans,
    reportSummaryState: state.reportSummary,
  };
};

const mapDispatchToProps = {
  fetchPlans: fetchPlansAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(NoSubscription);